export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8421.651e06f9.jpg";